import { MESApiService, type spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import type { ReturnedRollRow } from "../models/ReturnedRolls";

export interface GetReturnedRollsParams {
	start: string;
	end: string;
	signal?: AbortSignal;
}

// Fetch ALL returned rolls once (returned/scrapped/broken all on). The Status
// checkboxes filter the result client-side by the displayed status — this avoids
// the legacy bug where unchecking "Returned" switched the whole dataset to
// not-returned rolls (a mode switch instead of a real filter).
export const getReturnedRollsData = async ({
	start,
	end,
	signal,
}: GetReturnedRollsParams): Promise<ReturnedRollRow[]> => {
	const apiService = new MESApiService();
	// BIT params as JS booleans (the API rejects numbers). Always on — the UI
	// filter is applied client-side.
	// Only the real filters: the grid sorts client-side and datetimes come back
	// as raw UTC.
	const spName = "[ROLLS].[GetReturnedRollsDataWeb]";
	const parameters: spParameter[] = [
		{ name: "start", value: start },
		{ name: "end", value: end },
		{ name: "scrapped", value: true },
		{ name: "broken", value: true },
		{ name: "returned", value: true },
	];
	const resp = await apiService.callV2(spName, parameters, signal);

	if (!resp.ok) {
		throw new Error(resp.message || "Error fetching returned rolls");
	}
	return get(resp, "data.tables[0].rows", []) as ReturnedRollRow[];
};
